import { render, staticRenderFns } from "./ClaimExcess.vue?vue&type=template&id=36f735c0&scoped=true&"
import script from "./ClaimExcess.vue?vue&type=script&lang=js&"
export * from "./ClaimExcess.vue?vue&type=script&lang=js&"
import style0 from "./ClaimExcess.vue?vue&type=style&index=0&id=36f735c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f735c0",
  null
  
)

export default component.exports